import { render, staticRenderFns } from "./DisposalOrdersHead.vue?vue&type=template&id=3278f832&scoped=true"
import script from "./DisposalOrdersHead.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersHead.vue?vue&type=script&lang=js"
import style0 from "./DisposalOrdersHead.vue?vue&type=style&index=0&id=3278f832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3278f832",
  null
  
)

export default component.exports